import React, { useState } from 'react';
import { followUser, unfollowUser } from '../../lib/database';

/**
 * Bottone Segui / Segui già con aggiornamento ottimistico e rollback su errore.
 * - targetId: id dell'utente da seguire
 * - following: stato iniziale
 * - onChange(nextBool): notifica il parent (per aggiornare i conteggi)
 */
function FollowButton({ targetId, following, onChange, className = '' }) {
  const [isFollowing, setIsFollowing] = useState(!!following);
  const [busy, setBusy] = useState(false);

  const toggle = async (e) => {
    e.stopPropagation(); // non aprire la card / navigare
    if (busy) return;
    setBusy(true);
    const next = !isFollowing;
    setIsFollowing(next); // ottimistico
    const ok = next ? await followUser(targetId) : await unfollowUser(targetId);
    if (!ok) {
      setIsFollowing(!next); // rollback
    } else if (onChange) {
      onChange(next);
    }
    setBusy(false);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={busy}
      className={`shrink-0 px-4 py-1.5 rounded-full text-xs font-bold transition-colors disabled:opacity-60 ${
        isFollowing
          ? 'bg-gray-100 text-gray-600 border border-gray-200'
          : 'bg-primary-600 text-white'
      } ${className}`}
    >
      {isFollowing ? 'Segui già' : 'Segui'}
    </button>
  );
}

export default FollowButton;
